import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted'

export default function CookieBanner() {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (!accepted) {
      // Small delay so the page loads first, then banner slides in
      const timer = setTimeout(() => setVisible(true), 800)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, new Date().toISOString())
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="cookie-banner" role="complementary" aria-label={t('cookies.accept')}>
      <div className="cookie-banner-content">
        <p className="cookie-banner-text">{t('cookies.message')}</p>
        <button className="btn btn-primary cookie-banner-btn" onClick={handleAccept}>
          {t('cookies.accept')}
        </button>
      </div>
    </div>
  )
}
